import { useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      alert("Login error: " + error.message);
    } else {
      onLogin(data.session.user);
    }
  }

  return (
    <>
      <nav className="navbar navbar-light bg-light px-3">
        <span className="navbar-brand mb-0 h1">IA Images</span>
        <Link className="nav-link" to="/public_images">Public Images</Link>
      </nav>

      <div className="container mt-5">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <input className="form-control mb-2" type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
          <input className="form-control mb-2" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
          <button className="btn btn-primary" type="submit">Login</button>
        </form>
      </div>
    </>
  );
}
